import { connect } from 'react-redux';

const mapStateToProps = state => ({
  arealist: state.mainreducer.arealist,
});

export default ListViewLeftPart => connect(mapStateToProps)(ListViewLeftPart);
